import React from 'react';
import './map.css';
import Nav from '../components/layout/nav';
import { useNavigate } from 'react-router-dom';

const Map = () => {

    const navigate = useNavigate();

    return (
        <section>

            <div className="mapcontainer">

                <div className="mapbg">

                    <div className="mpoverlay ">

                        <div className="maptop">

                            <div
                                className="myticketback"
                                onClick={() => navigate(-1)}
                                role="button"
                                aria-label="Go back"
                            ></div>

                            <div className="maptitlediv">
                                <h2>Egypt Fashion Week</h2>
                                <h5 className='mmmmm'>Venue Map</h5>
                            </div>

                            <div className="mapsearch">
                                <div className="mapsearchicon"></div>
                                <h6>Main Hall Entrance</h6>
                            </div>

                        </div>

                        <div className="mapframe">

                            <iframe
                                title="Egypt Fashion Week Venue"
                                src="https://www.google.com/maps?q=Egypt+International+Exhibition+Center&output=embed"
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>

                            <div className="mapcard">

                                <div className="mapdot"></div>

                                <div className="mapcardtext">
                                    <h3>Main Venue</h3>
                                    <p>Egypt International Exhibition Center</p>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <Nav />

            </div>

        </section>
    );
};

export default Map;